import { useState, useEffect } from 'react'
import { Tree } from 'antd'
import { YhBox } from "@/components/YhBox";
import { useApprovalModel } from "../approvalModel";
import type { TreeProps } from 'antd/es/tree';
import '../approval.less'

export const Middle = () => {

  const {
    clone, shopTree,
    selectedShop, setSelectedShop,
    setAddApplyDrawer, setFlowNodes, setApplyUsers, setSelectFlow, setApprovalFlows,
  } = useApprovalModel()
  const [expanded, setExpanded] = useState<React.Key[]>(['scm']);

  //切换门店清除临时数据
  useEffect(() => {
    setAddApplyDrawer(false);
    setFlowNodes([]);
    setApplyUsers([]);
    setSelectFlow(undefined);
    setApprovalFlows([]);
  }, [selectedShop])

  const onSelect: TreeProps['onSelect'] = (selectedKeys, info) => {
    setSelectedShop(clone(info.selectedNodes[0]));
  };

  const onExpand: TreeProps['onExpand'] = (expandedKeys, info) => {
    if (expandedKeys.length > 0) {
      setExpanded(expandedKeys.map(e => e.toString()));
    }
    else {
      setExpanded([]);
    }
  };

  return (
    <YhBox width="100%" height="100%" title="选择系统" style={{ overflow: 'auto' }}>
      {shopTree && <Tree.DirectoryTree
        className="p-5"
        showLine={false}
        showIcon={false}
        treeData={shopTree}
        onSelect={onSelect}
        expandedKeys={expanded}
        onExpand={onExpand}
        expandAction={false}
      />}
    </YhBox>
  )
}